/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * メディアリストからメディアを削除した時の操作ログとして記録する内容
 * @export
 * @interface DeletedMediaOutletsOperationLog
 */
export interface DeletedMediaOutletsOperationLog {
    /**
     * メディアリストに対する操作の種類
     * @type {string}
     * @memberof DeletedMediaOutletsOperationLog
     */
    actionType: string;
    /**
     * 削除したメディアのidリスト
     * @type {Array<number>}
     * @memberof DeletedMediaOutletsOperationLog
     */
    deletedMediaOutletIds: Array<number>;
}

export function DeletedMediaOutletsOperationLogFromJSON(json: any): DeletedMediaOutletsOperationLog {
    return DeletedMediaOutletsOperationLogFromJSONTyped(json, false);
}

export function DeletedMediaOutletsOperationLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeletedMediaOutletsOperationLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actionType': json['action_type'],
        'deletedMediaOutletIds': json['deleted_media_outlet_ids'],
    };
}

export function DeletedMediaOutletsOperationLogToJSON(value?: DeletedMediaOutletsOperationLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action_type': value.actionType,
        'deleted_media_outlet_ids': value.deletedMediaOutletIds,
    };
}

